export const clientPermissions = ['Client', 'Client_Read', 'Client_Read_Own'];
export const clientWritePermissions = ['Client', 'Client_Write', 'Client_Write_Own'];
export const crmPermissions = ['CRM'].concat(clientPermissions);

export const quotePermission = ['Quote', 'Quote_Read', 'Quote_Read_Own'];
export const quoteWritePermission = ['Quote', 'Quote_Write', 'Quote_Write_Own'];
export const quoteGroupPermission = ['QuoteGroup', 'QuoteGroup_Read', 'QuoteGroup_Read_Own'];
export const quoteGroupWritePermission = ['QuoteGroup', 'QuoteGroup_Write', 'QuoteGroup_Write_Own'];
export const agentPermissions = ['Agent', 'Agent_Read', 'Agent_Read_Own'];
export const agentWritePermissions = ['Agent', 'Agent_Write', 'Agent_Write_Own'];
export const policyPermissions = ['Policy', 'Policy_Read'];
export const policyWritePermissions = ['Policy', 'Policy_Write'];
export const bookingPermissions = ['Booking'].concat(agentPermissions, quotePermission, policyPermissions);

export const productPermissions = ['Product', 'Product_Read'];
export const productWritePermissions = ['Product', 'Product_Write'];
export const productProviderPermissions = ['ProductProvider', 'ProductProvider_Read'];
export const productProviderWritePermissions = ['ProductProvider', 'ProductProvider_Write'];
export const supplierPermissions = ['Supplier', 'Supplier_Read', 'Supplier_Read_Own'];
export const supplierWritePermissions = ['Supplier', 'Supplier_Write', 'Supplier_Write_Own'];
export const productCategoryPermissions = ['ProductCategory', 'ProductCategory_Read'];
export const productCategoryWritePermissions = ['ProductCategory', 'ProductCategory_Write'];
export const allotmentPermissions = ['Allotment', 'Allotment_Read'];
export const allotmentWritePermissions = ['Allotment', 'Allotment_Write'];
export const productsPermissions = ['Products'].concat(productPermissions, productProviderPermissions, productCategoryPermissions, allotmentPermissions, supplierPermissions);

export const invoicePermission = ['Invoice', 'Invoice_Read'];
export const invoiceWritePermission = ['Invoice', 'Invoice_Write'];
export const paymentPermission = ['Payment', 'Payment_Read'];
export const paymentWritePermission = ['Payment', 'Payment_Write'];
export const accountingPermissions = ['Accounting'].concat(invoicePermission, invoiceWritePermission, paymentPermission, paymentWritePermission);

export const rulePermission = ['Rule', 'Rule_Read'];
export const ruleWritePermission = ['Rule', 'Rule_Write'];
export const rulesPermission = ['Rules', ...rulePermission, ...ruleWritePermission];

export const placePermission = ['Place', 'Place_Read'];
export const placeWritePermission = ['Place', 'Place_Write'];
export const regionPermission = ['Region', 'Region_Read'];
export const regionWritePermission = ['Region', 'Region_Write'];
export const entityMappingPermission = ['EntityMapping', 'EntityMapping_Read', 'EntityMapping_Write'];
export const geographyPermission = [...placePermission, ...regionPermission, ...entityMappingPermission];
export const currencyPermission = ['Currency', 'Currency_Read'];
export const currencyWritePermission = ['Currency', 'Currency_Write'];
export const currencyExchangePermission = ['CurrencyExchange', 'CurrencyExchange_Read'];
export const marketPermission = ['Market', 'Market_Read'];
export const marketWritePermission = ['Market', 'Market_Write'];
export const taxPermission = ['Tax', 'Tax_Read'];
export const taxWritePermission = ['Tax', 'Tax_Write'];
export const currenciesPermissions = [...currencyPermission, ...currencyExchangePermission, ...marketPermission, ...taxPermission];
export const brandPermission = ['Brand', 'Brand_Read'];
export const brandWritePermission = ['Brand', 'Brand_Write'];
export const docTemplatePermission = ['DocumentTemplate', 'DocumentTemplate_Read'];
export const docTemplateWritePermission = ['DocumentTemplate', 'DocumentTemplate_Write'];
export const docTemplateCategoryPermission = ['DocumentTemplateCategory', 'DocumentTemplateCategory_Read', 'DocumentTemplateCategory_Write'];
export const emailTemplatePermission = ['EmailDocumentTemplate', 'EmailDocumentTemplate_Read'];
export const emailTemplateWritePermission = ['EmailDocumentTemplate', 'EmailDocumentTemplate_Write'];
export const docsPermission = [...docTemplatePermission, ...docTemplateCategoryPermission, ...emailTemplatePermission, ...brandPermission];
export const userPermission = ['User', 'User_Read'];
export const userWritePermission = ['User', 'User_Write'];
export const profilePermission = ['User_Read_Own', 'User_Write_Own'];
export const taxonomyPermission = ['Taxonomy', 'Taxonomy_Read'];
export const taxonomyWritePermission = ['Taxonomy', 'Taxonomy_Write'];
export const schemaPermission = ['EntitySchema', 'EntitySchema_Read'];
export const schemaWritePermission = ['EntitySchema', 'EntitySchema_Write'];
export const extensibilityPermission = [...taxonomyPermission, ...schemaPermission];
export const languagePermission = ['Language', 'Language_Read'];
export const languageWritePermission = ['Language', 'Language_Write'];
export const airlinePermission = ['Airline', 'Airline_Read'];
export const airlineWritePermission = ['Airline', 'Airline_Write'];
export const configPermission = ['ConfigOption', 'ConfigOption_Read', 'ConfigOption_Write'];
export const apiKeyPermission = ['ApiKey', 'ApiKey_Read'];
export const apiKeyWritePermission = ['ApiKey', 'ApiKey_Write'];
export const otherPermission = [...languagePermission, ...configPermission, ...airlinePermission];
export const generalPermission = ['General'].concat(geographyPermission, currenciesPermissions, docsPermission, extensibilityPermission, otherPermission);

export const clientGDPRPermissions = ['ClientGDPR', 'ClientGDPR_Read', 'ClientGDPR_Read_Own'];
export const clientGDPRWritePermissions = ['ClientGDPR', 'Client_Write', 'Client_Write_Own'];
export const gdprPermissions = ['GDPR'].concat(clientGDPRPermissions, clientGDPRWritePermissions);

export const userTaskWrite = ['Task_Write'];
export const userTaskWriteStatus = ['Task_Change_Status', ...userTaskWrite];
export const userTaskWriteDeadline = ['Task_Change_Deadline', ...userTaskWrite];
export const userTaskWriteTitle = ['Task_Change_Title', ...userTaskWrite];
export const userTaskWritePriority = ['Task_Change_Priority', ...userTaskWrite];
export const userTaskWriteBody = ['Task_Change_Body', ...userTaskWrite];
export const userTaskWriteAssignment = ['Task_Change_User', ...userTaskWrite];

export const userTasksPermissions = ['UserTask', ...userTaskWrite]//, 'UserTask_Own_Write']

export const reportPermissions = ["Reports"];



// WEBPACK FOOTER //
// ./src/app/permissions.ts